// filepath: /Users/premysl/Desktop/web-app/plugins/aos.client.js
import AOS from 'aos';
import 'aos/dist/aos.css';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('app:mounted', () => {
        AOS.init({
            // You can add your AOS configuration options here
            duration: 1000,
            once: true,
        });
    });
});
